import type { AssignmentUser } from '@bliks-io/contracts';
import { UserCard, toUserCardProps } from '@bliks-io/ui';

interface ReviewUserSectionProps {
  label: string;
  user: AssignmentUser;
}

/**
 * Displays a user in a review modal with consistent section styling
 * Used for "Assigned By", "Recorded By", etc. sections
 */
export function ReviewUserSection({ label, user }: ReviewUserSectionProps) {
  return (
    <div className="space-y-2 h-full flex flex-col">
      <h3 className="text-sm font-medium">{label}</h3>
      <div className="rounded-lg border bg-muted/30 p-3 flex-1">
        <UserCard user={toUserCardProps(user)} variant="with-role" size="default" className="p-0" />
      </div>
    </div>
  );
}
